export const PROCESS_KILLED = '@@csp/PROCESS_KILLED'
export const PROCESS_KILL = '@@csp/PROCESS_KILL'
export const CLOSED = '@@csp/CLOSED'
export const NO_VAL = '@@csp/NO_VAL'
export const TICK = '@@csp/TICK'
export const MIX_MUTE = '@@csp/mix/MUTE'
export const MIX_PAUSE = '@@csp/mix/PAUSE'
export const MIX_SOLO = '@@csp/mix/PAUSE'
export const MIX_CHANGED = '@@csp/mix/CHANGED'



// WEBPACK FOOTER //
// ./src/internal/constants.js